export default __webpack_public_path__ + "static/media/sounds/ran_numbers_six.mp3";